<template>
  <HrPageLayout title="Shortlisting Management" subtitle="Shortlist candidates for interviews" :breadcrumb-items="[{ label: 'Recruitment' }, { label: 'Shortlisting' }]">
    <template #header-actions>
      <div class="hr-flex hr-flex-center hr-gap-2">
        <button class="hr-btn hr-btn-primary" @click="refresh">Refresh</button>
      </div>
    </template>

    <div class="hr-chart-card hr-mt-3">
      <div class="hr-chart-header">
        <h5 class="hr-chart-title"><i class="bx bx-filter"></i> Shortlisted Candidates</h5>
      </div>
      <div class="hr-chart-body">
        <div v-if="loading" class="hr-loading-state">
          <div class="hr-spinner"></div>
          <p>Loading shortlist...</p>
        </div>
        <div v-else-if="items.length === 0" class="hr-empty-state">
          <i class="bx bx-file"></i>
          <h5>No shortlisted candidates</h5>
          <p>Shortlist candidates from vacancies to proceed.</p>
        </div>
        <div v-else class="hr-table-wrapper">
          <table class="hr-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Candidate</th>
                <th>Vacancy</th>
                <th style="text-align:center">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(c, i) in items" :key="c.id">
                <td>{{ i + 1 }}</td>
                <td>{{ c.name }}</td>
                <td>{{ c.vacancyTitle }}</td>
                <td style="text-align:center"><span class="hr-badge hr-badge-info">{{ c.status }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </HrPageLayout>
</template>

<script>
/* eslint-disable */
import HrPageLayout from "@/components/hrActions/HrPageLayout.vue";
import { authUrl, execute } from "@/api";

export default {
  name: 'ShortlistingManagement',
  components: { HrPageLayout },
  data() { return { loading: false, items: [] }; },
  mounted() { this.fetchShortlist(); },
  methods: {
    async fetchShortlist() {
      this.loading = true;
      const data = new FormData();
      data.append('function', 'getShortlisted');
      try {
        const res = await execute(data, authUrl);
        if (res.data.success) this.items = res.data.data.items || [];
      } catch (e) { console.error(e); }
      this.loading = false;
    },
    refresh() { this.fetchShortlist(); }
  }
}
</script>
